// @flow
import type {AuthState} from 'store/reducers/auth'
import type {Dispatch, GetState, ThunkPromiseAction} from 'lib/definitions/redux'
import type {NotificationHistory} from 'lib/definitions/swagger'

import getDeviceInfo from '../../lib/shim/deviceInfo'
import WS from '../../lib/websocket'

import * as notificationAPI from '../../lib/api/notification'
import * as loadingActions from './loading'
import {pushRoute} from './router'
import {setAfterLoginRoute} from './auth'

export const NOTIFY_REGISTER_PUSH_NOTIFICATION				= 'NOTIFY_REGISTER_PUSH_NOTIFICATION'
export const NOTIFY_PROCESS_PUSH_NOTIFICATION_AFTER_LOGIN	= 'NOTIFY_PROCESS_PUSH_NOTIFICATION_AFTER_LOGIN'
export const NOTIFY_UPDATE_HISTORY	= 'NOTIFY_UPDATE_HISTORY'

export const PUSH_TYPE_NAVIGATE = 'NAVIGATE'

export function enablePushNotification(token : string){
	return (dispatch: Dispatch) => {
		return loadingActions.promise(
			dispatch,
			NOTIFY_REGISTER_PUSH_NOTIFICATION,
			notificationAPI.registerForPushNotifications(getDeviceInfo().getUniqueID(), `${getDeviceInfo().getSystemName()}-${getDeviceInfo().getSystemVersion()}`, token))
			.then((id : string) => WS.waitFor(id))
			.then(() => dispatch(_setPushNotificationRegistration(true)))
	}
}

/**
 * Save push notification registration
 * @return {{type: string}}
 */
function _setPushNotificationRegistration(registered : boolean){
	return {
		type: NOTIFY_REGISTER_PUSH_NOTIFICATION,
		registered: registered
	}
}


export type PushDataNavigate = {
	type: typeof PUSH_TYPE_NAVIGATE,
	to: string,
	meta?: Object
}

export type PushData = PushDataNavigate

/**
 * Process the push notification and dispatch it to the correct events
 * @param data
 */
export function processPushData(data : PushData){
	return (dispatch : Dispatch, getState : GetState) => {
		const Auth : AuthState = getState().Auth
		const isLoggedIn : boolean = Auth.token !== undefined

		switch(data.type){
			case PUSH_TYPE_NAVIGATE:
				if(isLoggedIn){
					dispatch(pushRoute(data.to, data.meta))
				}else{
					dispatch(setAfterLoginRoute(data.to, data.meta))
				}
				break

			default:
				console.log(`Unknown push notification type: ${data.type} with data ${JSON.stringify(data)}`)
		}

	}
}

export function getNotificationHistory(count : number = 20, offset : number = 0) : ThunkPromiseAction<Array<NotificationHistory>>{
	return (dispatch : Dispatch) =>
		loadingActions.promise(
			dispatch,
			NOTIFY_UPDATE_HISTORY,
			notificationAPI.getNotificationHistory(count, offset).then(response => {
				dispatch(_setNotificationHistory(response, offset !== 0))
				return response
			})
		)
}

function _setNotificationHistory(activity : Array<NotificationHistory>, append : boolean = false){
	return {
		type: NOTIFY_UPDATE_HISTORY,
		history: activity,
		append: append
	}
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/notify.js